<template>
  <div>
    <posts-table
      :config="config"
      :is-schedule="true"
    />
  </div>
</template>

<script>
import PostsTable from '@/views/owner-fb/poster/PostsTable'
import PostsTableConfig from './config/scheduled-posts-table-config'

export default {
  components: {
    PostsTable,
  },
  data() {
    return {
      config: PostsTableConfig,
    }
  },
}
</script>
